// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__mFNmQ","label":"Section_label__JwjB0","contentWrap":"Section_contentWrap__19lOZ","footer":"Section_footer__MWpDj","footerInner":"Section_footerInner__3-AdR"};